import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { RdsBundleSelectionListComponent } from './bundle-selection-list.component';
import { RdsFormatChipsPipe } from './format-chips.pipe';
import { RdsJoinFormatsPipe } from './join-formats.pipe';

const COMPONENTS = [RdsBundleSelectionListComponent];
const PIPES = [RdsFormatChipsPipe, RdsJoinFormatsPipe];

@NgModule({
  imports: [CommonModule, MatListModule, MatIconModule, FormsModule, FlexLayoutModule],
  declarations: [COMPONENTS, PIPES],
  exports: [COMPONENTS, PIPES],
})
export class RdsPackageBundleSelectionModule {}

export * from './bundle-selection-list.component';
export * from './format-chips.pipe';
export * from './join-formats.pipe';
